import {StateCreator} from "zustand/vanilla";
import {companyChangesReportsAPI} from "@/app/apiPaths";
import {GetChangesReportsResponse} from "@/pb/api/devplan/services/web/company";
import {jr} from "@/hooks/queries/response-handler";
import {ChangesReport, ProjectLinkedItems, ResolvedChange, ResolvedPerson} from "@devplaninc/codeup";

export type ChangesReportData = {
  reports: ChangesReport[]
  changes: Record<string, ResolvedChange>
  persons: Record<string, ResolvedPerson>
  projectLinks: ProjectLinkedItems[]
}

export type ChangesReportStoreState = {
  changesReports: Record<number, ChangesReportData>,
  fetchChangesReports(companyId: number): Promise<void>;
}

export const createChangesReportSlice: StateCreator<
  ChangesReportStoreState,
  [],
  [],
  ChangesReportStoreState
> = ((set) => ({
  changesReports: {},
  fetchChangesReports: async (companyId) => fetch(companyChangesReportsAPI(companyId))
    .then(jr)
    .then(js => {
      const {reportsJson, changesJson, personsJson, projectLinksJson} = GetChangesReportsResponse.fromJSON(js)
      const reports = reportsJson.map(json => ChangesReport.fromJSON(JSON.parse(json)))

      const changes: Record<string, ResolvedChange> = {}
      for (const json of changesJson) {
        const c = ResolvedChange.fromJSON(JSON.parse(json))
        changes[c.changeId] = c
      }

      const persons: Record<string, ResolvedPerson> = {}
      for (const json of personsJson) {
        const p = ResolvedPerson.fromJSON(JSON.parse(json))
        persons[p.personId] = p
      }

      const projectLinks = projectLinksJson.map(json => ProjectLinkedItems.fromJSON(JSON.parse(json)))

      set(s => ({
        ...s,
        changesReports: {...s.changesReports, [companyId]: {reports, changes, persons, projectLinks}},
      }))
    }),
}))
